module.exports = __webpack_public_path__ + "static/media/print-modal.3832555c.svg";